<template>
  <b-row>
    <b-col cols="12">
      <div
        class="w-100 d-flex flex-column flex-md-row align-items-md-center justify-content-md-between mt-3"
      >
        <h2>ویژگی ها</h2>
        <b-button variant="success" @click="addNewProperty"
          >افزودن ویژگی دلخواه</b-button
        >
      </div>
      <div
        class="w-100"
        v-if="
          (defaultProperties && defaultProperties.length > 0) ||
          (activeProperties && activeProperties.length > 0)
        "
      >
        <h3 class="mt-3">ویژگی های پیش فرض</h3>
        <hr />
        <app-collapse class="mb-3">
          <app-collapse-item
            :title="item.name"
            v-for="(item, index) in defaultProperties"
            :key="`default${index}`"
          >
            <div
              class="w-100 d-flex flex-column flex-md-row align-items-md-center justify-content-md-between"
            >
              <div class="w-50 mr-1">
                <b-form-group label="نام ویژگی" :label-for="`name${index}`">
                  <b-form-input
                    :id="`name${index}`"
                    :value="item.name"
                    readonly
                    trim
                    placeholder="پشتیبانی یا ..."
                  />
                </b-form-group>
              </div>
              <div class="w-50">
                <b-form-group label="مقدار ویژگی" :label-for="`value${index}`">
                  <b-form-input
                    :id="`value${index}`"
                    v-model="item.value"
                    trim
                    placeholder="پشتیبانی یا ..."
                  />
                </b-form-group>
              </div>
            </div>
            <b-button
              v-if="item.value"
              variant="danger"
              @click="renderDeleteConfirmationModal(item)"
              >حذف</b-button
            >
          </app-collapse-item>
          <app-collapse-item
            :title="item.name"
            v-for="(item, index) in activeProperties"
            :key="`active${index}`"
          >
            <div
              class="w-100 d-flex flex-column flex-md-row align-items-md-center justify-content-md-between"
            >
              <div class="half-on-desktop mr-1">
                <b-form-group
                  label="نام ویژگی"
                  :label-for="`active-name${index}`"
                >
                  <b-form-input
                    :id="`active-name${index}`"
                    :value="item.name"
                    trim
                    placeholder="پشتیبانی یا ..."
                  />
                </b-form-group>
              </div>
              <div class="half-on-desktop">
                <b-form-group
                  label="مقدار ویژگی"
                  :label-for="`active-value${index}`"
                >
                  <b-form-input
                    :id="`active-value${index}`"
                    v-model="item.value"
                    trim
                    placeholder="پشتیبانی یا ..."
                  />
                </b-form-group>
              </div>
            </div>
            <b-button
              variant="danger"
              @click="renderDeleteConfirmationModal(item)"
              >حذف</b-button
            >
          </app-collapse-item>
        </app-collapse>
      </div>
      <div class="w-100 mt-3">
        <h3>ویژگی های جدید</h3>
        <hr />
        <b-row>
          <b-col>
            <app-collapse v-if="newProperties && newProperties.length > 0">
              <div
                class="w-100 d-flex align-items-center"
                style="gap: 1rem"
                v-for="(item, index) in newProperties"
                :key="index"
              >
                <app-collapse-item title="ویژگی جدید" class="w-100">
                  <div
                    class="w-100 d-flex align-items-center justify-content-between"
                  >
                    <div class="w-50">
                      <b-form-group
                        label="نام ویژگی"
                        :label-for="`title${index}`"
                      >
                        <b-form-input
                          :id="`title${index}`"
                          :state="item.name && item.name != '' ? true : false"
                          v-model="item.name"
                          trim
                          placeholder="پشتیبانی یا ..."
                        />
                      </b-form-group>
                    </div>
                    <div class="w-50 ml-1">
                      <b-form-group
                        label="مقدار ویژگی"
                        :label-for="`value${index}`"
                      >
                        <b-form-input
                          :state="item.value && item.value != '' ? true : false"
                          :id="`value${index}`"
                          v-model="item.value"
                          trim
                          placeholder="دارد، ندارد یا ..."
                        />
                      </b-form-group>
                    </div>
                  </div>
                </app-collapse-item>
                <feather-icon
                  icon="Trash2Icon"
                  class="text-danger"
                  style="cursor: pointer"
                  size="20"
                  @click="removeNewProperty(item)"
                />
              </div>
            </app-collapse>
            <div v-else>
              <p class="text-center">هیچ ویژگی جهت نمایش وجود ندارد</p>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-col>
    <b-modal
      title="حذف ویژگی"
      id="modal-property-delete"
      centered
      ok-title="حذف"
      cancel-title="بستن"
      @ok="sendPropertyRemoveRequest"
      @cancel="closeDeleteConfirmationModal"
    >
      آیا از حذف ویژگی اطمینان دارید؟
    </b-modal>
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BDropdown,
  BDropdownItem,
  BModal,
} from "bootstrap-vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { GetAllCourseTypeProperties } from "@/libs/Api/CourseTypeProperty";
import {
  CreateProperties,
  GetObjectPropertiesOf,
  DeleteProperty,
  UpdateAProperty,
} from "@/libs/Api/Property";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  props: {
    // Type 1 is for course, 2 is for lesson
    objectType: {
      type: [Number, String],
      required: true,
    },
    courseTypeId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      newProperties: [],
      defaultProperties: null,
      activeProperties: null,
      tempPropertyObject: null,
      updatingProperties: [],
    };
  },
  async created() {
    await this.getAllCourseTypeProperties();
    await this.getPropertiesOfThisEntity();
  },
  methods: {
    async sendPropertyRemoveRequest() {
      try {
        let _this = this;
        let deleteProperty = new DeleteProperty(_this);
        deleteProperty.setRequestParamDataObj([
          _this.tempPropertyObject.propertyId,
        ]);
        await deleteProperty.fetch(
          async function (response) {
            await _this.getPropertiesOfThisEntity();
            await _this.getAllCourseTypeProperties();
            await _this.handleDefaultAndActiveProperties();
            _this.closeDeleteConfirmationModal();
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      }
    },
    renderDeleteConfirmationModal(property) {
      this.tempPropertyObject = JSON.parse(JSON.stringify(property));
      this.$bvModal.show("modal-property-delete");
    },
    closeDeleteConfirmationModal() {
      this.$bvModal.hide("modal-property-delete");
      this.tempPropertyObject = null;
    },
    removeNewProperty(property) {
      this.newProperties = this.newProperties.filter(
        (item) => item != property
      );
    },
    async getPropertiesOfThisEntity() {
      try {
        let _this = this;
        let getObjectPropertiesOf = new GetObjectPropertiesOf(_this);
        getObjectPropertiesOf.setRequestParam({
          objectId: _this.$route.params.id,
          propertyType: _this.objectType,
        });
        await getObjectPropertiesOf.fetch(
          function (response) {
            if (response.isSuccess) {
              _this.activeProperties = response.data;
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.handleDefaultAndActiveProperties();
      }
    },
    handleDefaultAndActiveProperties() {
      this.activeProperties.forEach((item) => {
        item["isUpdating"] = true;
        let tempProp = this.defaultProperties.find(
          (property) => property.name == item.name
        );
        if (tempProp) {
          this.activeProperties = this.activeProperties.filter(
            (prop) => prop.name != tempProp.name
          );
          this.$set(tempProp, "value", item.value);
          this.$set(tempProp, "isUpdating", true);
          this.$set(tempProp, "propertyId", item.propertyId);
          this.$set(tempProp, "objectId", item.objectId);
          this.$set(tempProp, "objectType", this.objectType);
        }
      });
    },
    transferDefaultPropertiesToNewPropertiesArray() {
      // this.defaultProperties.forEach((item) => {
      //   if (item.value && item.value != "" && !item.isUpdating) {
      //     this.newProperties.push({
      //       isDeleted: false,
      //       propertyId: 0,
      //       objectId: this.$route.params.id,
      //       objectType: this.objectType,
      //       name: item.name,
      //       value: item.value,
      //     });
      //   } else if (item.value && item.value != "" && item.isUpdating) {
      //     // this.updatingProperties.push(item);
      //     this.updatingProperties.push({
      //       isDeleted: false,
      //       propertyId: item.propertyId,
      //       objectId: item.objectId,
      //       objectType: this.objectType,
      //       name: item.name,
      //       value: item.value,
      //     });
      //   }
      // });
      this.activeProperties.forEach((item) => {
        if (item.value && item.value != "" && !item.isUpdating) {
          this.newProperties.push({
            isDeleted: false,
            propertyId: 0,
            objectId: this.$route.params.id,
            objectType: this.objectType,
            name: item.name,
            value: item.value,
          });
        } else if (item.value && item.value != "" && item.isUpdating) {
          // this.updatingProperties.push(item);
          this.updatingProperties.push({
            isDeleted: false,
            propertyId: item.propertyId,
            objectId: item.objectId,
            objectType: this.objectType,
            name: item.name,
            value: item.value,
          });
        }
      });
    },
    async updatePropertyList(item) {
      try {
        let _this = this;
        let updateAProperty = new UpdateAProperty(_this);
        updateAProperty.setRequestParamDataObj(item);
        await updateAProperty.fetch(
          async function (response) {
            if (response.message == "OperationSucceeded") {
              _this.$toast({
                component: ToastificationContent,
                props: {
                  title: "ویژگی با موفقیت بروزرسانی شد",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
              _this.updatingProperties = [];
              await _this.getAllCourseTypeProperties();
              await _this.getPropertiesOfThisEntity();
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.handleDefaultAndActiveProperties();
      }
    },
    async createPropertyList() {
      // CAUTION: This method is called
      // in parent component By ref
      this.transferDefaultPropertiesToNewPropertiesArray();
      console.log(this.newProperties);
      if (this.newProperties && this.newProperties.length > 0) {
        let hasError = false;
        this.newProperties.forEach((item) => {
          if (!item.name || !item.value) {
            hasError = true;
          }
        });
        if (!hasError) {
          try {
            let _this = this;
            let createProperties = new CreateProperties(_this);
            createProperties.setRequestParamDataObj(_this.newProperties);
            await createProperties.fetch(
              function (response) {
                if (
                  response.isSuccess &&
                  response.data &&
                  response.data.creationRecorsCount > 0
                ) {
                  _this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: `${response.data.creationRecorsCount} ویژگی ایجاد شد`,
                      icon: "EditIcon",
                      variant: "success",
                    },
                  });
                  _this.newProperties = [];
                }
              },
              function (error) {
                console.error(error);
              }
            );
          } catch (error) {
            console.error(error);
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `توجه`,
              icon: "",
              variant: "danger",
              text: `اطلاعات ویژگی ها صحیح نمی‌باشد.`,
            },
          });
        }
      }
      if (this.updatingProperties && this.updatingProperties.length > 0) {
        this.updatingProperties.forEach(async (item) => {
          await this.updatePropertyList(item);
        });
      }
      await this.getPropertiesOfThisEntity();
    },
    async getAllCourseTypeProperties() {
      try {
        let _this = this;
        let getAllCourseTypeProperties = new GetAllCourseTypeProperties(_this);
        getAllCourseTypeProperties.setRequestParam({
          count: 0,
          pageNumber: 0,
          courseTypeId: _this.courseTypeId,
        });
        await getAllCourseTypeProperties.fetch(
          function (response) {
            if (response.isSuccess) {
              _this.defaultProperties = response.data.courseTypeProperties;
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      }
    },
    addNewProperty() {
      this.newProperties.push({
        isDeleted: false,
        propertyId: 0,
        objectId: this.$route.params.id,
        objectType: this.objectType,
        name: null,
        value: null,
      });
    },
  },
  computed: {
    // filteredDefaultProperties() {
    //   if (this.defaultProperties && this.defaultProperties.length > 0) {
    //     let filteredProperties = this.defaultProperties.filter(item => this.activeProperties.includes(secondItem => {
    //         if(item.name != secondItem.name){P}
    //       item.name
    //     }))
    //   }
    // },
  },
  components: {
    BRow,
    BCol,
    BFormInput,
    BForm,
    BFormGroup,
    BButton,
    BDropdown,
    BDropdownItem,
    AppCollapse,
    AppCollapseItem,
    BModal,
  },
};
</script>
<style scoped>
@media only screen and (max-width: 767px) {
  .half-on-desktop {
    width: 100%;
  }
}
@media only screen and (min-width: 768px) {
  .half-on-desktop {
    width: 50%;
  }
}
</style>
